import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export default function PageTransition({ children }) {
  const location = useLocation();
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.animation = 'none';
    void el.offsetHeight;
    el.style.animation = '';
  }, [location.pathname]);

  return (
    <div ref={ref} className="page-transition" style={{ minHeight: '100%' }}>
      {children}
    </div>
  );
}
